import { Button } from "@/components/ui/button";
import { Menu, X, ShoppingCart } from "lucide-react";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User, Session } from "@supabase/supabase-js";

const Header = () => {
  const [user, setUser] = useState<User | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Set up auth state listener FIRST
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setSession(session);
        setUser(session?.user ?? null);
      }
    );

    // THEN check for existing session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);
  return <header className="bg-card border-b border-border sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <a href="/" className="flex items-center">
            <img 
              src="/lovable-uploads/5d93235f-6f03-4b9a-bad9-ebf8c52967ce.png" 
              alt="Yumeli Logo" 
              className="h-12 w-auto"
              loading="eager"
              width="73"
              height="48"
              style={{ maxWidth: "73px", height: "auto" }}
            />
          </a>
        </div>
        
        <nav className="hidden md:flex items-center gap-6">
          <a href="/" className="text-foreground hover:text-primary transition-colors">
            Accueil
          </a>
          <a href="/activites" className="text-foreground hover:text-primary transition-colors">
            Voir les activités
          </a>
          <a href="/avis" className="text-foreground hover:text-primary transition-colors">
            Vos avis
          </a>
          {user ? (
            <a href="/compte" className="text-foreground hover:text-primary transition-colors">
              <Button variant="outline" size="sm">
                Mon compte
              </Button>
            </a>
          ) : (
            <a href="/connexion" className="text-foreground hover:text-primary transition-colors">
              <Button variant="outline" size="sm">
                Se connecter
              </Button>
            </a>
          )}
          <a href={user ? "/commande" : "/connexion?redirect=/commande"} className="text-foreground hover:text-primary transition-colors">
            <Button size="sm" className="bg-primary hover:bg-primary/90 text-white">
              <ShoppingCart className="w-4 h-4 mr-2" />
              Panier
            </Button>
          </a>
        </nav>
        
        <div className="md:hidden flex items-center gap-2">
          <a href={user ? "/commande" : "/connexion?redirect=/commande"}>
            <Button size="sm" className="bg-primary hover:bg-primary/90 text-white">
              <ShoppingCart className="w-4 h-4" />
            </Button>
          </a>
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </Button>
        </div>
      </div>
      
      {/* Menu mobile */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-card border-t border-border">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            <a href="/" className="text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
              Accueil
            </a>
            <a href="/activites" className="text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
              Voir les activités
            </a>
            <a href="/avis" className="text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
              Vos avis
            </a>
            {user ? (
              <a href="/compte" className="text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                <Button variant="outline" size="sm" className="w-full justify-start">
                  Mon compte
                </Button>
              </a>
            ) : (
              <a href="/connexion" className="text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                <Button variant="outline" size="sm" className="w-full justify-start">
                  Se connecter
                </Button>
              </a>
            )}
            <a href={user ? "/commande" : "/connexion?redirect=/commande"} className="text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
              <Button size="sm" className="bg-primary hover:bg-primary/90 text-white w-full">
                <ShoppingCart className="w-4 h-4 mr-2" />
                Panier
              </Button>
            </a>
          </nav>
        </div>
      )}
    </header>;
};
export default Header;